import { createFormGroupState, updateGroup, validate } from 'ngrx-forms';
import { greaterThan, required } from 'ngrx-forms/validation';

export const PAYMENT_CHARGE_FORM_ID = 'Payment_charge_form_id';

export interface PaymentChargeFormState {
  currency: string | null,
  paymentType: string | null,
  amount: number,
}

export const initialPaymentChargeFormValue: PaymentChargeFormState = {
  currency: 'USD',
  paymentType: null,
  amount: 0,
};

export const initialPaymentChargeFormState = createFormGroupState<PaymentChargeFormState>(
  PAYMENT_CHARGE_FORM_ID,
  initialPaymentChargeFormValue,
);

export const validatePaymentChargeForm = updateGroup<PaymentChargeFormState>({
  currency: validate(required),
  paymentType: validate(required),
  amount: validate(greaterThan(0.1)),
});

